import axios from "axios";
import defaultImage from "../components/icons/Header.png";

export async function fetchServices(userId, page = 1, limit = 10, defaultImage) {
  try {
    const response = await axios.post("/api/servicescustom", { 
      userID: userId,
      page,
      limit
    });

    let services = response.data.items || [];

    services = services.map((s) => ({
      ...s,
      imageUrl: defaultImage,
    }));

    return {
      services,
      total: response.data.total,
      currentPage: response.data.currentPage,
      totalPages: response.data.totalPages
    };
  } catch (err) {
    console.error("Error fetching services:", err.message || err);
    return { services: [], total: 0, currentPage: 1, totalPages: 1 };
  }
}


export async function loadServiceImages(services, defaultImage) {
  const updated = await Promise.all(
    services.map(async (service) => {
      const serviceImages = service.serviceImages || [];
      const activeImage = serviceImages.find(
        (img) => img.isActive === "true"
      );

      if (activeImage?.filepath) {
        try {
          const fileRes = await axios.post(
            "/api/file/get",
            { fileName: activeImage.filepath },
            { responseType: "blob" }
          );
          // Validate blob has data
          if (!fileRes.data || fileRes.data.size === 0) {
            if (import.meta.env.DEV) {
              console.warn("Empty blob for service image:", activeImage.filepath);
            }
            service.imageUrl = defaultImage;
          } else {
            // Check content-type
            const contentType = fileRes.data.type || fileRes.headers['content-type'] || "image/jpeg";
            if (!contentType.startsWith('image/')) {
              if (import.meta.env.DEV) {
                console.warn("Invalid content-type for service image:", contentType);
              }
              service.imageUrl = defaultImage;
            } else {
              const blob = new Blob([fileRes.data], { type: contentType });
              if (blob.size === 0) {
                service.imageUrl = defaultImage;
              } else {
                service.imageUrl = URL.createObjectURL(blob);
              }
            }
          }
        } catch (error) {
          console.error("Error loading service image:", error.message || error);
          service.imageUrl = defaultImage;
        }
      } else {
        service.imageUrl = defaultImage;
      }

      return service;
    })
  );

  return updated;
}
